import { useState, useContext, useEffect } from "react";
import {  FaEdit, FaFile,  FaPlusCircle, FaTrashAlt, FaUmbrella } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import Dialogs from "components/ui/dialogs/dialogs";
import ContratPrevoyancePagerBDD from "../AuditComplet/Prevoyance/ContratPrevoyance/ContratPrevoyancePagerBDD";
import SearchField from "components/ui/controls/search-field";
import {
  createStyledButton,
} from "components/ui/controls/button/button-styles";
import { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import "./BddContrat.css";

// Composant ContratCard moderne inspiré de ClientCard
const ContratCard = ({ contrat, onEdit, onDelete, onCopy, showCopy = false }) => {
  return (
    <div className="contrat-card">
      <div className="contrat-card-content">
        <div className="contrat-card-icon">
          <FaUmbrella />
        </div>

        <div className="contrat-card-info">
          <h4 className="contrat-card-title">
            {contrat.LibelleContrat}
          </h4>
          <div className="contrat-card-meta">
            <span className="contrat-card-badge">
              Nature du contrat : {contrat.Nature || "Contrat de prévoyance"}
            </span>
          </div>
        </div>
      </div>

      {contrat.ContratMAKOFormation === undefined && (
        <div className="contrat-card-actions">
          <Button
            onClick={onEdit}
            icon
            {...createStyledButton("card-action", "cardEdit")}
          >
            <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
          </Button>

          <Button
            onClick={onDelete}
            icon
            {...createStyledButton("card-action", "delete")}
          >
            <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
          </Button>

          {showCopy && (
            <Button
              onClick={onCopy}
              icon
              className="contrat-card-copy-button"
              title="Copier le contrat"
            >
              <FaFile />
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

const BddContrat = (props) => {
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    context.handleListeUserContratPrevoyance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filtrer les contrats selon la recherche
  const filteredContracts = context.state.ListeContratPrevoyance?.filter(contrat =>
    contrat.LibelleContrat?.toLowerCase().includes(searchText.toLowerCase()) ||
    contrat.Nature?.toLowerCase().includes(searchText.toLowerCase())
  ) || [];

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row center>
              <Column className="contrat-search-section">
                <Button
                  {...createStyledButton("primary")}
                  className="contrat-add-button"
                  onClick={() => {
                    context.handleNewUserContratPrevoyance();
                    setmodalOpen(true);
                  }}
                >
                  <FaPlusCircle />
                  Ajouter un nouveau contrat
                </Button>
              </Column>
              <Column className="contrat-search-field">
                <SearchField
                  value={searchText}
                  large
                  placeholder="Rechercher un contrat"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
              </Column>
            </Row>
          </Column>
        </CardBox>
        <CardBox>
          <Column fill>
            <Row>
              <Column scroll fill>
                <div className="contrat-list-container">
                  <CardBoxHeader icon={<FaUmbrella />}>
                    Liste des contrats de prévoyance ({filteredContracts?.length || 0})
                  </CardBoxHeader>

                  {filteredContracts?.length === 0 ? (
                    <div className="contrat-empty-state">
                      <FaUmbrella />
                      <p>
                        {searchText ? "Aucun contrat trouvé pour cette recherche" : "Aucun contrat trouvé"}
                      </p>
                    </div>
                  ) : (
                    filteredContracts?.map((contrat, index) => (
                      <ContratCard
                        key={"ContratBB" + index}
                        contrat={contrat}
                        onEdit={() => {
                          context.handleModifyUserContratPrevoyance(contrat.IdContrat);
                          setmodalOpen(true);
                        }}
                        onDelete={() => {
                          Dialogs.confirm(
                            "Vous êtes sur le point de supprimer le contrat de la base de données. Voulez-vous continuer ?",
                            "Suppression d'un contrat",
                            () => {
                              context.handleDeleteUserContratPrevoyance(contrat.IdContrat);
                            }
                          );
                        }}
                        onCopy={() => {
                          context.handlCopyUserContratPrevoyance(contrat.IdContrat);
                        }}
                        showCopy={context.state.IdUser === 2000 || context.state.IdUser === 2284}
                      />
                    ))
                  )}
                </div>
              </Column>
            </Row>
          </Column>
        </CardBox>
      </Column>

      <Modal
        hideClose={true}
        width="80%"
        height="80%"
        title="Ajout d'un contrat de prévoyance existant"
        icon={<FaUmbrella />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ContratPrevoyancePagerBDD
          visible={modalOpen}
          onClose={() => {
            setmodalOpen(false);
          }}
        />
      </Modal>
    </>
  );
};

export default BddContrat;
